package koala.dom

import kotlinx.js.JsPlainObject
import web.dom.Element

/** The browser's `IntersectionObserver`. */
external class IntersectionObserver {
    constructor(
        callback: (Array<IntersectionObserverEntry>, IntersectionObserver) -> Unit
    )
    constructor(
        callback: (Array<IntersectionObserverEntry>, IntersectionObserver) -> Unit,
        options: IntersectionObserverInit
    )

    fun observe(target: Element)
    fun unobserve(target: Element)
    fun disconnect()
}

@JsPlainObject
external interface IntersectionObserverEntry {
    val target: Element
    val isIntersecting: Boolean
    val intersectionRatio: Double
}

@JsPlainObject
external interface IntersectionObserverInit {
    var root: Element?
    var rootMargin: String?
    var threshold: dynamic
}

/** Calls [block] each time the element enters or leaves the viewport, with whether it is visible. */
fun Element.onView(block: (Boolean) -> Unit) {
    val observer = IntersectionObserver { entries, _ ->
        entries.forEach { entry ->
            block(entry.isIntersecting)
        }
    }

    observer.observe(this)
}

/** Calls [block] once, the first time the element enters the viewport. */
fun Element.onFirstView(block: () -> Unit) {
    val observer = IntersectionObserver { entries, obs ->
        entries.forEach { entry ->
            if (entry.isIntersecting) {
                block()
                obs.disconnect()
            }
        }
    }

    observer.observe(this)
}